<template>
    <v-dialog v-model="show" max-width="600px" :persistent="loading" scrollable>
        <v-card class="pa-4">
            <v-card-title>
                Assinar contrato
            </v-card-title>
            <v-card-text>
                <v-form ref="formContract">
                    <v-row>
                        <v-col v-if="error_message" cols="12">
                            <v-alert type="error darken-4">
                                {{ error_message }}
                            </v-alert>
                        </v-col>
                        <v-col v-if="success_message" cols="12">
                            <v-alert type="success">
                                {{ success_message }}
                            </v-alert>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="contract_file"
                                accept=".pdf"
                                label="Arquivo do contrato (PDF) assinado"
                                :rules="[basic_rules.required]"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row no-gutters justify="space-between">
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" dark color="primary-pink" elevation="0" @click="close"><v-icon left>mdi-arrow-u-left-top</v-icon> Voltar</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" dark color="primary-blue" elevation="0" @click="save()">Assinar <v-icon right>mdi-check-bold</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        contractData: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            show: this.value,
            basic_rules: {
                required: value => !!value || "Informação obrigatória"
            },

            contract_file: null,
            
            loading: false,
            error_message: null,
            success_message: null
        };
    },
    watch: {
        value() {
            this.show = this.value;
        },
        show() {
            if (!this.show) {
                this.contract_file = null;
                this.$emit("close");
            }

            this.loading = false;
            this.error_message = null;
            this.success_message = null;
            this.$emit("input", this.show);
        },
    },
    methods: {
        ...mapActions("customers", ["ActionDoSignContract"]),
        close() {
            this.$refs.formContract.reset();
            this.show = false;
        },
        save() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formContract.validate()) {
                const formData = new FormData();
                formData.append('contract_id', this.contractData.id);
                formData.append('contract_file', this.contract_file);

                this.ActionDoSignContract(formData)
                    .then(response => {
                        if (response.status) {
                            this.success_message = "Contrato assinado salvo com sucesso";
                            this.$refs.formContract.reset();
                            this.loading = false;
                            this.$emit("signed");
                            this.show = false;
                        } else {
                            this.error_message = "Houve um erro ao salvar o contrato assinado";
                            this.loading = false;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.error_message = error.response?.data || "Erro inesperado";
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        }

    }
};
</script>
